import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import Box from '@mui/material/Box';

import { CHILDREN_PROP_TYPES } from 'propTypes';
import { isMobileMedia } from 'bento-ordering/utils/media';
import muiPropForwarding from 'styles/helpers/muiPropForwarding';

const Wrapper = styled(Box, {
  shouldForwardProp: muiPropForwarding(
    'isVisible',
    'isMobile',
    'justifyContent',
    'isInMoreSection',
    'hideOnMobile'
  )
})(
  ({
    theme,
    isVisible,
    isMobile,
    justifyContent,
    isInMoreSection,
    hideOnMobile
  }) => {
    const isVisibleOrMobile = isVisible || isMobile;

    return {
      justifyContent,
      opacity: isVisibleOrMobile ? 'inherit' : '0',
      zIndex: isVisibleOrMobile ? 'inherit' : '-1',
      position: isVisibleOrMobile ? 'inherit' : 'absolute',
      padding: '0 10px',
      display: 'flex',
      alignItems: 'center',
      '& .MUISvgIcon-root': {
        fill: theme.palette.text.disabled
      },
      '@media (hover)': {
        '&:hover': {
          cursor: 'pointer',
          '& *': {
            fill: theme.palette.sectionNav.link.hover,
            color: theme.palette.sectionNav.link.hover
          }
        }
      },
      '&:first-of-type': {
        paddingLeft: isInMoreSection ? '10px' : '2px'
      },
      /**
       * This media query is use to adjust the padding on the first child
       * which is slightly off at a specific width
       */
      // eslint-disable-next-line no-useless-computed-key
      ['@media (max-width:1300px) and (min-width: 1255px)']: {
        '&:first-of-type': {
          paddingLeft:
            !isInMoreSection && window.navigator.userAgent.indexOf('Win') !== -1
              ? '10px'
              : '2px'
        }
      },
      [theme.breakpoints.down('lg')]: {
        '&:first-of-type': {
          paddingLeft: isInMoreSection ? '8px' : '16px'
        }
      },
      [theme.breakpoints.down('md')]: {
        color: 'blue',
        padding: '0 10px 0 8px',
        display: hideOnMobile ? 'none' : 'flex',
        justifyContent: 'flex-end',
        '& .MuiSvgIcon-root': {
          fill: theme.palette.secondary.main,
          display: 'flex',
          alignItems: 'center'
        }
      }
    };
  }
);

const MenuSectionsBarNavLinkWrapper = ({
  children,
  dataTestId,
  handleClick,
  id,
  onFocus,
  ...rest
}) => {
  const { hideOnMobile, justifyContent, isInMoreSection, isVisible } = rest;

  return (
    <Wrapper
      id={id}
      data-testid={dataTestId}
      onClick={handleClick}
      onFocus={onFocus}
      isVisible={isVisible}
      isMobile={isMobileMedia()}
      justifyContent={justifyContent}
      isInMoreSection={isInMoreSection}
      hideOnMobile={hideOnMobile}
    >
      {children}
    </Wrapper>
  );
};

MenuSectionsBarNavLinkWrapper.defaultProps = {
  justifyContent: 'flex-end',
  isInMoreSection: false
};

MenuSectionsBarNavLinkWrapper.propTypes = {
  children: CHILDREN_PROP_TYPES,
  hideOnMobile: PropTypes.bool,
  dataTestId: PropTypes.string,
  handleClick: PropTypes.func,
  paddingLeft: PropTypes.string,
  paddingRight: PropTypes.string,
  id: PropTypes.string,
  justifyContent: PropTypes.string,
  isInMoreSection: PropTypes.bool,
  isVisible: PropTypes.bool,
  onFocus: PropTypes.func
};

export default MenuSectionsBarNavLinkWrapper;
